module.exports = __webpack_public_path__ + "img/terms.092c1b3.svg";